import { Card } from "@components/Card";
import styled from "@emotion/styled";
import React from "react";

import { SHARED_PALETTE } from "@every.org/common/src/display/palette";
import { spacing } from "@every.org/common/src/display/spacing";
import { NonprofitAdminStatus } from "@every.org/common/src/entity/types";
import {
  getRoutePath,
  URLFormat,
  ClientRouteName,
} from "@every.org/common/src/helpers/clientRoutes";

import { Link } from "src/components/Link";
import { useLoggedInUserOrUndefined } from "src/context/AuthContext/hooks";
import { LinkAppearance } from "src/styles/link";
import { verticalStackCss } from "src/theme/spacing";
import {
  FontWeight,
  textSizeCss,
  TextSize,
  numPxTextSizes,
} from "src/theme/text";

const MAX_TEXT_WIDTH = 900;

const StyledCard = styled(Card)`
  ${verticalStackCss.s};
  align-items: center;
  text-align: center;
  padding: ${spacing.xl} ${spacing.l};
  * {
    max-width: ${MAX_TEXT_WIDTH}px;
  }
  h2 {
    font-size: ${numPxTextSizes[TextSize.m]}px;
    font-weight: ${FontWeight.MEDIUM};
    color: ${SHARED_PALETTE.error};
  }
`;

export const NonprofitWarningCard = () => {
  const loggedInUser = useLoggedInUserOrUndefined();
  const adminFor = (loggedInUser?.adminFor || []).filter((nonprofitAdmin) =>
    [NonprofitAdminStatus.REQUESTED, NonprofitAdminStatus.CONFIRMED].includes(
      nonprofitAdmin.status
    )
  );

  if (!loggedInUser || adminFor.length < 1) {
    return null;
  }

  const adminLink =
    adminFor.length === 0
      ? getRoutePath({
          format: URLFormat.RELATIVE,
          name: ClientRouteName.NONPROFIT_ADMIN,
          tokens: { nonprofitSlug: adminFor[0].nonprofit.primarySlug },
        })
      : getRoutePath({
          format: URLFormat.RELATIVE,
          name: ClientRouteName.MANAGE_NONPROFITS,
        });

  return (
    <StyledCard>
      <h2>
        WARNING: Below is NOT for your nonprofit, it&apos;s if you personally
        would like to make donations.
      </h2>
      <Link
        data-tname="recentContributorName"
        to={adminLink}
        css={textSizeCss.s}
        appearance={LinkAppearance.HYPERLINK}
      >
        Go here to manage your nonprofit.
      </Link>
    </StyledCard>
  );
};
